<div mat-dialog-title>
    <h1>{{ data.name }}</h1>
    <button mat-button
            mat-dialog-close
            [attr.aria-label]="'generic.close' | translate"
            [matTooltip]="'generic.close' | translate">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>
<mat-dialog-content>
    <div class="media">
        <img [src]="data.unLocked ? data.image : 'assets/'+ brand +'/images/success-locked.svg'" />
    </div>
    <div class="data">
        <h2>{{ data.name }}</h2>
        <div [innerHTML]="data.criteria"></div>
    </div>
</mat-dialog-content>